export const environment = {
  production: true,
  hmr: false,
  canonicalDomain: 'https://www.mullerbog.nl',
};
